import { PageConfig } from "../../router";
import ProviderForm from "../../components/dashboard/provider/ProviderForm";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Luna - Booking Page",
  description: "Luna - Booking Page",
};

export default function AddProviderPage() {
  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="dashboard__main h-100">
        <div className="dashboard__content bg-light-2 h-100 w-100">
          <div className="d-flex flex-column h-100 mb-20 overflow-y-scroll">
            <ProviderForm />
          </div>
        </div>
      </div>
    </>
  );
}

export const AddProviderPageConfig: PageConfig = {
  path: "/providers/add",
  component: AddProviderPage,
  roles: ["admin", "root"],
};
